var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container",on:{"click":_vm.validaOpenModal}},[_c('img',{staticClass:"whatsFixed",attrs:{"src":require("@/assets/allImages/WHATSAPP.svg"),"data-bs-toggle":"modal","data-bs-target":"#exampleModal"}}),_c('ModalWpp',{attrs:{"valida":_vm.valida}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }